import React from 'react';
import { Leaf, PlusCircle, MinusCircle } from 'lucide-react';
export function Reframe() {
  return <section className="py-10 bg-gray-50" data-id="element-379">
      <div className="container mx-auto px-4" data-id="element-380">
        <div className="max-w-4xl mx-auto text-center mb-16" data-id="element-381">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-gray-800" data-id="element-382">
            De Dependencia a Autonomía
          </h2>
          <p className="text-xl mb-8" data-id="element-383">
            Esto no es un producto más. Es una elección de vida. La decisión de
            dejar de depender de químicos para sentirte bien.
          </p>
          <p className="text-xl mb-12" data-id="element-384">
            La diferencia entre calmar el dolor y sanar la causa… es inmensa. Y
            ahora está en tus manos.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-385">
          <div className="bg-white p-8 rounded-xl shadow-md" data-id="element-386">
            <div className="flex items-center mb-6" data-id="element-387">
              <div className="bg-red-100 p-3 rounded-full mr-4" data-id="element-388">
                <MinusCircle size={28} className="text-red-500" data-id="element-389" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-390">Enfoque Tradicional</h3>
            </div>
            <ul className="space-y-4" data-id="element-391">
              <li className="flex items-start" data-id="element-392">
                <span className="text-red-500 mr-2" data-id="element-393">✕</span>
                <span data-id="element-394">Medicamentos que solo enmascaran el dolor</span>
              </li>
              <li className="flex items-start" data-id="element-395">
                <span className="text-red-500 mr-2" data-id="element-396">✕</span>
                <span data-id="element-397">Efectos secundarios indeseados</span>
              </li>
              <li className="flex items-start" data-id="element-398">
                <span className="text-red-500 mr-2" data-id="element-399">✕</span>
                <span data-id="element-400">Dependencia química a largo plazo</span>
              </li>
              <li className="flex items-start" data-id="element-401">
                <span className="text-red-500 mr-2" data-id="element-402">✕</span>
                <span data-id="element-403">Tratamiento solo de síntomas, no de causas</span>
              </li>
            </ul>
          </div>
          <div className="bg-white p-8 rounded-xl shadow-md border-2 border-blue-500" data-id="element-404">
            <div className="flex items-center mb-6" data-id="element-405">
              <div className="bg-blue-100 p-3 rounded-full mr-4" data-id="element-406">
                <PlusCircle size={28} className="text-blue-500" data-id="element-407" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-408">Enfoque Natural</h3>
            </div>
            <ul className="space-y-4" data-id="element-409">
              <li className="flex items-start" data-id="element-410">
                <span className="text-green-500 mr-2" data-id="element-411">✓</span>
                <span data-id="element-412">Terapia no invasiva que respeta tu cuerpo</span>
              </li>
              <li className="flex items-start" data-id="element-413">
                <span className="text-green-500 mr-2" data-id="element-414">✓</span>
                <span data-id="element-415">Sin efectos secundarios negativos</span>
              </li>
              <li className="flex items-start" data-id="element-416">
                <span className="text-green-500 mr-2" data-id="element-417">✓</span>
                <span data-id="element-418">Libertad de medicamentos</span>
              </li>
              <li className="flex items-start" data-id="element-419">
                <span className="text-green-500 mr-2" data-id="element-420">✓</span>
                <span data-id="element-421">Aborda las causas profundas del dolor</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="text-center mt-12" data-id="element-422">
          <p className="text-xl font-semibold text-blue-600" data-id="element-423">
            🔔 Cada día con pastillas es un día más lejos de tu equilibrio
            natural.
          </p>
        </div>
      </div>
    </section>;
}